/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global document, Office */
import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./ui/App";

Office.onReady((info) => {
  if (info.host !== Office.HostType.Word) {
    return;
  }

  const container = document.getElementById("root");
  if (!container) {
    return;
  }

  const root = createRoot(container);
  root.render(React.createElement(App));
});
